import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { redirectToOAuthSignIn } from '../utils/oauth.js'
import { useAuthConfig } from '../config/appConfig.jsx'
import { PAGE_FORM } from '../lib/layout.js'

// SignInPage is a redirect stub.
//
// Pre-v7 this page hosted two flows; the second was a credential-collection
// form posting cross-origin to the legacy V2 auth endpoint on behalf of the
// Bitol AS. bitol.svc#394 deleted that surface and moved the credential
// form onto the AS itself (api.jgp.ai/signin, see SigninController). The AS
// no longer bounces users to next.actianlabs.com/signin for credentials, so
// Flow B is dead and has been removed (#244).
//
// All that remains is Flow A: we are an OAuth CLIENT, kick a fresh PKCE
// /oauth2/authorize roundtrip with whatever `?return=` path the caller
// asked for. The page paints nothing visible — it's a redirect stub.
export default function SignInPage() {
  const [params] = useSearchParams()
  const authConfig = useAuthConfig()
  const rawReturn = params.get('return')
  const returnTo = rawReturn && !rawReturn.startsWith('http') ? rawReturn : '/admin'

  useEffect(() => {
    redirectToOAuthSignIn(authConfig, { returnTo }).catch((err) => {
      console.error('[signin] OAuth redirect failed:', err)
    })
  }, [returnTo, authConfig])

  return (
    <main className={`${PAGE_FORM} pb-12 pt-12`}>
      <p className="text-sm text-slate-600">Redirecting to sign-in…</p>
    </main>
  )
}
